import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

export function getActiveClassroomsQuery() {
  return resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', masqueradeStore.getUserIdByMasqueradeState(), 'classrooms_v1'])
    .include('students_v1')
    .include('subjects_v1')
    .filter({
      status: 'active'
    })
    .pageSize(250);
}

export function handleDateChange(
  classroomObj,
  chosenDateSetting,
  selectedClassrooms,
  setSelectedClassrooms,
  classroomId
) {
  const newClassroomObj = {...classroomObj, ...chosenDateSetting};
  const updatedClassrooms = selectedClassrooms.set(classroomId, newClassroomObj);
  setSelectedClassrooms(updatedClassrooms);
}

export function validDateRange(startDate, endDate) {
  // Only validate if both dates are filled out
  if (typeof startDate === 'string' && typeof endDate === 'string') {
    if (new Date(startDate) > new Date(endDate)) {
      return false;
    }
  }
  return true;
}

export function validTimeRange(startDate, endDate, startDateTime, endDateTime) {
  if (typeof startDateTime === 'string' && typeof endDateTime === 'string') {
    // Only validate if both times are filled out and if startDate and endDate are the same
    if (
      startDateTime !== '' &&
      endDateTime !== '' &&
      new Date(startDate).toDateString() === new Date(endDate).toDateString()
    ) {
      if (startDateTime > endDateTime) {
        return false;
      }
    }
  }
  return true;
}
